import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import FalconCardHeader from '@/components/common/FalconCardHeader';
import Flex from '@/components/common/Flex';
import AgGridWrapper from '@/app/common/components/ag-grid/AgGridWrapper';
import { combinationColumnConfig } from '@/app/KeywordResearch/config/combinationColumnConfig';
import { keywordsCombination } from '@/helpers/keywordsCombination';
import {
  useEffect,
  useRef,
  useState,
  type ChangeEvent,
  type ComponentType,
  type Dispatch,
  type FormEvent,
  type SetStateAction
} from 'react';
import { Button, Card, Col, Form, Row } from 'react-bootstrap';
import { useOutletContext } from 'react-router-dom';

type BreadcrumbItem = { text: string; href: string };
type OutletContext = [
  BreadcrumbItem[],
  Dispatch<SetStateAction<BreadcrumbItem[]>>
];

type WordItem = {
  word: string;
  required: boolean;
  key: number;
  length: number;
};

type AgGridWrapperProps = {
  settings?: Record<string, unknown>;
  height: string;
  columns: unknown;
  data?: unknown[] | null;
};

const TypedAgGridWrapper = AgGridWrapper as ComponentType<AgGridWrapperProps>;

const Combination = () => {
  const [, setBreadcrumbData] = useOutletContext<OutletContext>();
  useEffect(() => {
    setBreadcrumbData([{ text: 'ترکیب کلمات', href: '#' }]);
  }, [setBreadcrumbData]);
  const limit = 5;
  const [inputText, setInputText] = useState('');
  const [wordsArray, setWordsArray] = useState<WordItem[]>([]);
  const gridRef = useRef<HTMLDivElement>(null);
  const [gridData, setGridData] = useState<unknown[]>([]);
  const handleDelete = (index: number) => {
    const newArray = [...wordsArray].filter((_, i) => i !== index);
    setWordsArray(newArray);
  };
  const handleRequiredToggle = (index: number) => {
    const copy = [...wordsArray];
    copy[index].required = !copy[index].required;
    setWordsArray(copy);
  };
  const handleAdd = (e: FormEvent) => {
    e.preventDefault();
    const copy = [...wordsArray];
    copy.push({
      word: inputText,
      required: true,
      key: copy.length + 1,
      length: inputText.length
    });
    setWordsArray(copy);
    setInputText('');
  };

  const handleEdit = (e: ChangeEvent<HTMLInputElement>, index: number) => {
    const copy = [...wordsArray];
    copy[index].word = e.target.value;
    setWordsArray(copy);
  };
  return (
    <Row>
      <Col md={5} xs={12}>
        <Card className="mt-3" style={{ minHeight: 700 }}>
          <FalconCardHeader
            className="py-2"
            titleTag="h6"
            light
            title="بهتره تک کلمه در هر بخش وارد کنی"
          />
          <Card.Body>
            <form onSubmit={handleAdd}>
              <div className="input-group input-group-md position-relative">
                <Form.Control
                  type="text"
                  disabled={wordsArray.length < limit ? false : true}
                  style={{
                    direction: 'auto'
                  }}
                  placeholder={`کلمه‌ای که میخوایی ترکیب کنی وارد کن`}
                  value={inputText}
                  onChange={e => setInputText(e.target.value)}
                />
                <Button
                  type="submit"
                  style={{
                    borderRadius: '5px 0 0 5px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                  disabled={inputText.length > 0 ? false : true}
                  variant="outline-primary"
                  title="افزودن کلمه"
                >
                  <FontAwesomeIcon icon="plus" />
                </Button>
              </div>
            </form>
            <Flex direction="column" className="gap-2 my-2">
              {wordsArray.map(({ word, required }, i) => (
                <div
                  key={i}
                  className="input-group input-group-sm position-relative"
                >
                  <Form.Control
                    type="text"
                    style={{
                      direction: 'auto'
                    }}
                    placeholder={word.length > 0 ? '' : 'کلمه نباید خالی باشه'}
                    value={word}
                    onChange={e => handleEdit(e, i)}
                  />
                  <Button
                    type="button"
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}
                    onClick={() => {
                      handleRequiredToggle(i);
                    }}
                    variant="outline-primary"
                    active={required}
                    title="اجباری"
                  >
                    <FontAwesomeIcon
                      className="mx-1"
                      icon={required ? 'check' : 'times'}
                    />
                    اجباری
                  </Button>
                  <Button
                    type="button"
                    style={{
                      borderRadius: '5px 0 0 5px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}
                    onClick={() => {
                      handleDelete(i);
                    }}
                    variant="outline-danger"
                    title="حذف کلمه"
                  >
                    <FontAwesomeIcon icon="trash-alt" className="fs-0" />{' '}
                  </Button>
                </div>
              ))}
            </Flex>
            <Button
              disabled={wordsArray.some(item => item.word === '')}
              className="w-100 mx-1 mt-auto"
              variant="falcon-primary"
              onClick={() => {
                const generatedKeyWords = keywordsCombination(wordsArray);
                setGridData(generatedKeyWords);
              }}
            >
              ترکیب کن {`(${wordsArray.length}/${limit})`}
            </Button>
          </Card.Body>
        </Card>
      </Col>
      <Col md={7} xs={12}>
        <div ref={gridRef}>
          <TypedAgGridWrapper
            settings={{
              pagination: false,
              fullscreen: false,
              changeHeight: false,
              resetGrid: false,
              saveGrid: false,
              sideBar: true,
              exportBtn: false
            }}
            height="700px"
            columns={combinationColumnConfig}
            data={[...gridData]}
          />
        </div>
      </Col>
    </Row>
  );
};

export default Combination;
